import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'dashboard-v2-student-feedbacks',
  templateUrl: './student-feedbacks.component.html',
})
export class DashboardV2StudentFeedbacksComponent {
  @Input() feedbacks: any[] = [];
  @Input() pagerLabel = '';
  @Input() pages: string[] = [];
  @Input() activePage = '';
  @Input() loading = false;
  @Input() error = '';
  @Output() studentClick = new EventEmitter<any>();
  @Output() pageChange = new EventEmitter<string>();

  selectedFeedback: any = null;

  openFeedbackDetails(feedback: any, event: Event): void {
    event.stopPropagation();
    this.selectedFeedback = feedback;
  }

  closeFeedbackDetails(): void {
    this.selectedFeedback = null;
  }

  @HostListener('document:keydown.escape')
  closeFeedbackDetailsOnEscape(): void {
    this.closeFeedbackDetails();
  }
}
